document.addEventListener('alpine:init', () => {
    Alpine.data('CountryPicker', (countryCode = 'GB') => ({
        isOpen: false, 
        isRegionModalOpen: false, 
        countryCode: countryCode,
        territorySelect(href) {
            //keeping this function incase there is any additional logic we need to do here. For example IP detection
            this.isOpen = false;
            window.location.href = href;
        }
    }));
});
